/* FK cookie control v3 (2026-10-10)
   Controls Shopify's built-in cookie banner (#shopify-pc__banner):
   - shows it only after 9s
   - if unanswered: shows again only after 7 days
   - once answered (accept/decline): never shows again, consent re-applied on each visit
   v2: reapply() retries with polling; banner stays hidden (fk-cc-hold) until reapply succeeds/exhausts retries.
   v3: the answer is stored in BOTH localStorage and a 1-year first-party cookie (fk_cc_v1),
       so it survives if the browser wipes one of them; the hide rule covers any #shopify-pc__banner* element.
   No consent is ever assumed or applied before a real stored answer exists.
   If this script fails to run, the banner behaves exactly as Shopify's default.
   Ported to Focal theme 2026-10-24 (identical to Boost theme's assets/fk-cookie-control.js) */
(function(){
  var KEY='fk_cc_v1', DELAY=9000, WEEK=7*24*60*60*1000;
  var RETRY_INTERVAL=300, MAX_RETRIES=20;
  var d=document, h=d.documentElement;
  function ckRead(){
    try{var m=d.cookie.match(/(?:^|; )fk_cc_v1=([^;]*)/);return m?(JSON.parse(decodeURIComponent(m[1]))||{}):{}}catch(e){return {}}
  }
  function ckWrite(s){
    try{
      var o={answered:s.answered||'',answeredAt:s.answeredAt||0,shown:s.shown||0};
      d.cookie=KEY+'='+encodeURIComponent(JSON.stringify(o))+'; max-age=31536000; path=/; SameSite=Lax'+(location.protocol==='https:'?'; Secure':'');
    }catch(e){}
  }
  function load(){
    var a={},b=ckRead(),r={},k;
    try{a=JSON.parse(localStorage.getItem(KEY)||'{}')||{}}catch(e){}
    for(k in b) r[k]=b[k];
    for(k in a) if(a[k]) r[k]=a[k];
    if(!r.answered&&b.answered){r.answered=b.answered;r.answeredAt=b.answeredAt}
    if((b.shown||0)>(r.shown||0)) r.shown=b.shown;
    return r;
  }
  function save(s){try{localStorage.setItem(KEY,JSON.stringify(s))}catch(e){} ckWrite(s)}
  var s=load();
  if(s.answered) save(s);
  var st=d.createElement('style'); st.id='fk-cc-style';
  st.textContent='html.fk-cc-hold [id^="shopify-pc__banner"]{display:none!important}';
  (d.head||h).appendChild(st);
  h.classList.add('fk-cc-hold');
  var due=!s.answered && (!s.shown || Date.now()-s.shown>WEEK);
  if(due){
    setTimeout(function(){
      s=load(); if(s.answered) return;
      s.shown=Date.now(); save(s);
      h.classList.remove('fk-cc-hold');
    },DELAY);
  }
  d.addEventListener('visitorConsentCollected',function(e){
    var dt=(e&&e.detail)||{};
    var acc=!!(dt.analyticsAllowed||dt.marketingAllowed||dt.preferencesAllowed);
    s=load(); s.answered=acc?'accepted':'declined'; s.answeredAt=Date.now(); save(s);
    h.classList.add('fk-cc-hold');
  });
  function applyConsent(cp){
    try{
      var cur=cp.currentVisitorConsent?cp.currentVisitorConsent():null;
      if(cur&&(cur.analytics||cur.marketing)) return true;
      var v=s.answered==='accepted';
      cp.setTrackingConsent({analytics:v,marketing:v,preferences:v,sale_of_data:v},function(){});
      return true;
    }catch(e){return false}
  }
  function reapply(){
    if(!s.answered) return;
    var attempts=0;
    function tryApply(){
      attempts++;
      var cp=window.Shopify&&window.Shopify.customerPrivacy;
      if(cp&&cp.setTrackingConsent){
        if(applyConsent(cp)) return;
      }
      if(attempts<MAX_RETRIES){
        if(window.Shopify&&window.Shopify.loadFeatures&&attempts===1){
          window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){
            if(!err){
              var cp2=window.Shopify&&window.Shopify.customerPrivacy;
              if(cp2&&cp2.setTrackingConsent) applyConsent(cp2);
            }
          });
        }
        setTimeout(tryApply,RETRY_INTERVAL);
      }
    }
    tryApply();
  }
  if(d.readyState==='loading') d.addEventListener('DOMContentLoaded',reapply); else reapply();
})();
